import { UserDto as HellojoyUserDto } from '~/api/public/models'
import { useOutletContext } from 'react-router-dom'

type OutletContextType = { user: HellojoyUserDto }

export function usePublicUser() {
  return useOutletContext<OutletContextType>()
}
